<script setup>
import { onLaunch, onError, onUnhandledRejection } from '@dcloudio/uni-app'
import { useUserStore } from '@/store/user'

// [修复] 全局错误兜底，防止未捕获异常导致白屏
onError((err) => {
  console.error('[App Error]', err)
})

// [修复] 全局未处理 Promise 异常兜底
onUnhandledRejection((res) => {
  console.error('[App UnhandledRejection]', res.reason || res)
})

onLaunch(async () => {
  console.log('App Launch')
  const userStore = useUserStore()

  // [修复] 监听网络状态变化，断网时提示用户
  uni.onNetworkStatusChange((res) => {
    if (!res.isConnected) {
      uni.showToast({ title: '网络连接已断开', icon: 'none', duration: 2000 })
    }
  })

  if (userStore.isLoggedIn) {
    // 有 token（本地未过期）直接进主页；自动登录改由登录页「一键登录」按钮触发
    // [改动原因] 原无条件 reLaunch 首页会覆盖企微消息卡片等外部链接带入的落地路由
    // （如 /#/pages/order/detail?id=xxx），导致点击通知总是跳到首页；
    // 仅当落地页为登录页或默认入口时才跳主页，直达业务页面时保留原路由
    const hash = (typeof window !== 'undefined' && window.location.hash) || ''
    const target = hash.startsWith('#/') ? hash.slice(1) : hash
    if (!target || target === '/' || target.startsWith('/pages/login/index')) {
      uni.reLaunch({ url: '/pages/index/index' })
    }
  }
  // 无 token：登录页为首页（pages.json 首项），停留登录页由用户发起一键登录或手动登录
})
</script>

<style>
page {
  background-color: #f5f5f5;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}
</style>
